import { Toolbar, Typography } from "@material-ui/core";
import React from "react";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import { PrimaryButton, SecondaryButton } from "@prestosports/commons-ui";
import { PlayInsertionType } from "@prestosports/prestostats-core/Football";
import { useFootballContext } from "../../../state/football-play/context";
import ValidationErrors from "../../common/components/ValidationErrors";
import SubmitCancelListener from "./listeners/SubmitCancelListener";
import { useAppContext } from "../../../state/app/context";

const useStyles = makeStyles(() => ({
	content: {
		padding: "20px 0"
	}
}));

const PlaySummary = ({ play, validationMessages = [], hideControls }) => {
	const classes = useStyles();

	const { state: appState } = useAppContext();
	const isSubmitting = appState.isSubmitting();
	const isInsertingPlay = !!appState.insertPlay();
	const insertType = appState.insertType();
	const { finalize, startOver, insertNewPlay, toggleInsertPlayMode } =
		useFootballContext();
	const { messages } = play;
	const message = messages.join(" ");

	const submitDisabled =
		validationMessages.some((m) => m.type === "error") || isSubmitting;
	const cancelDisabled = isSubmitting;

	const handleSubmit = () => (isInsertingPlay ? insertNewPlay() : finalize());
	const handleCancel = () => {
		if (!cancelDisabled) {
			const isReplacement = insertType === PlayInsertionType.Replace;
			if (isInsertingPlay && isReplacement) {
				toggleInsertPlayMode(null);
			} else {
				startOver();
			}
		}
	};

	return (
		<>
			<Box className={classes.content}>
				<Box mb={2}>
					<ValidationErrors errors={validationMessages} />
				</Box>
				<Typography variant="h6">This play will be saved:</Typography>
				{message && <Typography variant="subtitle1">{message}</Typography>}
			</Box>
			{!hideControls && (
				<>
					<Toolbar disableGutters>
						<Grid
							container
							direction="row"
							justifyContent="flex-end"
							alignItems="center"
							spacing={1}
						>
							<Grid item>
								<SecondaryButton
									onClick={handleCancel}
									variant="contained"
									label="Cancel"
								/>
							</Grid>
							<Grid item>
								<PrimaryButton
									onClick={handleSubmit}
									label="Save"
									disabled={submitDisabled}
								/>
							</Grid>
						</Grid>
					</Toolbar>
					<SubmitCancelListener
						cancelDisabled={cancelDisabled}
						submitDisabled={submitDisabled}
						onSubmit={handleSubmit}
						onCancel={startOver}
					/>
				</>
			)}
		</>
	);
};

export default PlaySummary;
